import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const deliveryApi = createApi({
    reducerPath:"deliveryApi" ,
    baseQuery : fetchBaseQuery({
        baseUrl:  import.meta.env.VITE_API + "delivery_type" ,
        prepareHeaders : (headers) => {
            headers.set("Content-Type" , "application/json")
            return headers ;
        }
    }),
    endpoints : (builder) => ({
        getDeliveries : builder.query({
            query : () => ({
                url:"?single_data=false&page=1&no_of_docs_each_page=10",
                method:"GET"
            })
        })
    })
})
export const {useGetDeliveriesQuery} = deliveryApi